module.exports = __webpack_public_path__ + "img/09.ad3132e8.jpg";